import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { postLoginData, setLoginError } from "../../Reducers/Login/Actions";
import Login from "../../Components/Login/Login";
import { DefaultRootState } from "../../Types/Types";

const LoginContainer = (props) => {
  const dispatch = useDispatch();
  const { isValidLogin, loginError, token } = useSelector((state: DefaultRootState) => state.login);
  return (<Login
      {...props}
      isValidLogin={isValidLogin}
      loginError={loginError}
      token={token}
      triggerLogin={(username, password) => dispatch(postLoginData(username, password))}
      setLoginError={(hasError) => dispatch(setLoginError(hasError))}
    />)
}

export default LoginContainer